import { render, staticRenderFns } from "./ClubRoster.vue?vue&type=template&id=243b47f6&scoped=true&"
import script from "./ClubRoster.vue?vue&type=script&lang=ts&"
export * from "./ClubRoster.vue?vue&type=script&lang=ts&"
import style0 from "./ClubRoster.vue?vue&type=style&index=0&id=243b47f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243b47f6",
  null
  
)

export default component.exports